// GENERATED FILE — config/brand.json'dan scripts/brand/generate.py üretir; elle düzenleme
export interface Brand {
  appName: string;
  companyName: string;
  primaryDomain: string;
  stagingDomain: string | null;
  marketingDomain: string | null;
  supportEmail: string | null;
  legacyDomains: readonly string[];
}

const DEFAULT_BRAND: Brand = {
  appName: "Senseiverse",
  companyName: "Senseiverse",
  primaryDomain: "senseiverse.net",
  stagingDomain: "dev.senseiverse.net",
  marketingDomain: "senseiverse.com",
  supportEmail: "support@senseiverse.com",
  legacyDomains: [],
};

// Adres adına göre seçilen markalar (aktif profilden ayrı; boşsa herkes varsayılanı görür).
const HOST_BRANDS: readonly Brand[] = [
  {
    appName: "Kulis",
    companyName: "Senseiverse",
    primaryDomain: "kulisapp.com",
    stagingDomain: "dev.kulisapp.com",
    marketingDomain: "senseiverse.com",
    supportEmail: "support@kulisapp.com",
    legacyDomains: ["senseiverse.net"],
  },
];

export function resolveBrand(hostname: string): Brand {
  // Sondaki nokta (tam nitelikli ad: `kulisapp.com.`) aynı adrestir.
  const host = hostname.trim().toLowerCase().replace(/\.+$/, '');
  for (const brand of HOST_BRANDS) {
    for (const domain of [brand.primaryDomain, brand.stagingDomain]) {
      if (domain && (host === domain || host.endsWith(`.${domain}`))) return brand;
    }
  }
  return DEFAULT_BRAND;
}

export const BRAND: Brand = resolveBrand(
  // `window` yok: bu dosyayı DOM tipleri olmayan tsconfig.node (vite.config.ts) de derler.
  (globalThis as { location?: { hostname?: string } }).location?.hostname ?? '',
);

// Adres adına göre varsayılandan farklı bir marka seçildi mi (ör. belge başlığı yalnız o zaman değişir).
export const IS_HOST_BRAND: boolean = BRAND !== DEFAULT_BRAND;
